import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { auth } from "@/lib/api";

import Landing from "@/pages/Landing";
import PartnerSignup from "@/pages/PartnerSignup";
import PartnerLogin from "@/pages/PartnerLogin";
import PartnerDashboard from "@/pages/PartnerDashboard";
import ReferralDetail from "@/pages/ReferralDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import EmployeeSignup from "@/pages/EmployeeSignup";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import PartnerReferralView from "@/pages/PartnerReferralView";
import Apply from "@/pages/Apply";
import ClientLogin from "@/pages/ClientLogin";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminEmployeeDetail from "@/pages/AdminEmployeeDetail";
import PartnerDetail from "@/pages/PartnerDetail";
import TeamLogin from "@/pages/TeamLogin";

const SubmitReferralRedirect = () => {
  const code = auth.getUser()?.referral_code || "";
  return <Navigate to={code ? `/apply?ref=${code}` : "/apply"} replace />;
};

const RequireRole = ({ role, children }) => {
  const current = auth.getRole();
  if (current !== role) {
    const redirect =
      role === "admin" ? "/team/login" :
      role === "employee" ? "/team/login" :
      role === "client" ? "/client/login" : "/partner/login";
    return <Navigate to={redirect} replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/partner/signup" element={<PartnerSignup />} />
          <Route path="/partner/login" element={<PartnerLogin />} />
          <Route path="/team/login" element={<TeamLogin />} />
          {/* Backward-compat: old separate URLs now route to unified login */}
          <Route path="/admin/login" element={<Navigate to="/team/login" replace />} />
          <Route path="/employee/login" element={<Navigate to="/team/login" replace />} />
          <Route path="/employee/signup" element={<EmployeeSignup />} />
          <Route path="/client/login" element={<ClientLogin />} />

          <Route path="/client/dashboard" element={<RequireRole role="client"><ClientDashboard /></RequireRole>} />

          <Route path="/partner/dashboard" element={<RequireRole role="partner"><PartnerDashboard /></RequireRole>} />
          <Route path="/partner/submit-referral" element={<SubmitReferralRedirect />} />
          <Route path="/partner/referrals/:id" element={<RequireRole role="partner"><PartnerReferralView /></RequireRole>} />

          <Route path="/admin/dashboard" element={<RequireRole role="admin"><AdminDashboard /></RequireRole>} />
          <Route path="/admin/employees/:id" element={<RequireRole role="admin"><AdminEmployeeDetail /></RequireRole>} />
          <Route path="/admin/partners/:id" element={<RequireRole role="admin"><PartnerDetail /></RequireRole>} />
          <Route path="/admin/referrals/:id" element={<RequireRole role="admin"><ReferralDetail adminView={true} /></RequireRole>} />

          <Route path="/employee/dashboard" element={<RequireRole role="employee"><EmployeeDashboard /></RequireRole>} />
          <Route path="/employee/partners/:id" element={<RequireRole role="employee"><PartnerDetail /></RequireRole>} />
          <Route path="/employee/referrals/:id" element={<RequireRole role="employee"><ReferralDetail adminView={true} /></RequireRole>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
